/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { Link, graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import FlexaLogo from "./FlexaLogo";
import Footer from "./Footer";
import Header from "./Header";
import Spacer from "./Spacer";
import Wrapper from "./Wrapper";

/*
Full Width 1600
|-Gutter 168-|-Main 1270-|-Gutter 168-|
*/

const SiteWrapper = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;

  display: flex;
  flex-direction: row;
`;

const Content = styled.div`
  flex: 1 0 76%;
  width: 100%;
`;

const Gutter = styled.div`
  flex: 1 1 12%;
  position: relative;
  max-width: 10.5rem;
  min-width: 5rem;
  padding-left: var(--unit);
  padding-right: var(--unit);
`;

const Feet = styled.div`
  height: 10px;
  width: 100%;
  background-image: linear-gradient(
    17.51deg,
    var(--gradient-start) -8.9%,
    var(--gradient-end) 192.03%
  );
`;

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <SiteWrapper
        css={css`
          position: fixed;
          z-index: 1;
          height: 0;
        `}
      >
        <Gutter
          css={css`
            height: 100vh;
          `}
        >
          <div
            css={css`
              position: relative;
              top: 3.75rem;
              height: var(--menu-height);

              display: flex;
              justify-content: center;

              z-index: 1;
            `}
          >
            <Link to="/">
              <FlexaLogo />
            </Link>
          </div>
        </Gutter>
        <Content></Content>
        <Gutter />
      </SiteWrapper>

      <Spacer rem={3.75}></Spacer>
      <Wrapper
        css={css`
          z-index: 1;
        `}
      >
        <Header siteTitle={data.site.siteMetadata.title} />
      </Wrapper>
      <main>{children}</main>

      <Wrapper>
        <Footer />
      </Wrapper>

      <Feet></Feet>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
